import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { ChartBaseDirective } from '@client/app/modules/charts/directives/chart-base.directive';
import { DEFAULT_CHART_SETTINGS } from '@client/app/modules/charts/constants/Chart.constant';
import { LegendCursorService } from '@client/app/modules/charts/services/LegendCursor.service';

@Component({
    selector: 'mon-chart-doughnut',
    templateUrl: './doughnut.component.html',
    imports: [
        ChartBaseDirective,
    ],
})
export class DoughnutComponent implements OnInit, OnChanges {
    @Input() labels: any[] = [];
    @Input() data: any[] = [];
    @Input() options: any = {};
    @Input() size: any = '';
    @Input() colors: any[] = [
        DEFAULT_CHART_SETTINGS.CHART.COLORS.GREEN_BLUE,
        DEFAULT_CHART_SETTINGS.CHART.COLORS.LIGHT_GRAY,
    ];
    @Input() series: any[] = [];
    @Input() override: any = {};

    constructor (private legendCursorService: LegendCursorService) {}

    ngOnInit (): void {
        this.options = this.options || {
            cutoutPercentage: DEFAULT_CHART_SETTINGS.CHART.CUTOUT_PERCENTAGE,
        };
        this.options = this.legendCursorService.setHoverState(this.options);
    }

    ngOnChanges (): void {
        if (!this.data) {
            return;
        }

        if (!(this.options !== null && typeof this.options === 'object')) {
            this.options = {};
        }

        if (!(this.options.centerText !== null && typeof this.options.centerText === 'object')) {
            this.options.centerText = {};
        }

        if (this.data.filter(function (data) {
            return data > 0;
        }).length === 0) {
            this.data = [0, 1];
            this.options.centerText = {
                totalFontSize: 150,
                totalLabel: this.options.centerText.emptyText ? this.options.centerText.emptyText : 'No data available',
            };
        }
    }
}
